import { AppTheme } from "@backstage/core-plugin-api";
import { themes as backstageThemes, UnifiedThemeProvider } from "@backstage/theme";
import { CssBaseline } from "@material-ui/core";

const wrapTheme =
  (theme: typeof backstageThemes.light): AppTheme["Provider"] =>
  ({ children }) =>
    (
      <UnifiedThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </UnifiedThemeProvider>
    );

export const themes: AppTheme[] = [
  {
    id: "light",
    title: "Light",
    variant: "light",
    Provider: wrapTheme(backstageThemes.light),
  },
  {
    id: "dark",
    title: "Dark",
    variant: "dark",
    Provider: wrapTheme(backstageThemes.dark),
  },
];
